import React  from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import HeaderMenu from './Header/HeaderMenu';
import SidebarSub from './Filters/Sidebarsub';
import Config from '../../config/index';
import {renderHTML} from '../../util/RenderHtml';
import Loader from '../../containers/Modal';
import Pagination from "react-paginate";
import isEmptyObj from '../../util/EmptyObject'
import qs from 'qs';
import './style.css';
import { Redirect } from 'react-router';
import {getDeviceType} from '../../util/GetDeviceType'
import Helmet from 'react-helmet'
import ReactGA from 'react-ga4';

 let count = 0;
 const defaultImage = 'no-image-available.jpg'
 const devicetype = getDeviceType()
class Productlist extends React.Component{


    constructor() {
        super();
        this.state = { selectedFilters:{} , productData :[],filedir: Config.s3bucket,showProgress:true,
          toggleKey: '', pageNumber:1,totalPages:'',totalItemCount:'',pageSize:5,isreload: true,
          selectedIndustry:[],selectedBusiness:[], selectedApplication:[], selectedOfferingType: [],
          selectedSubType :[], searchKey : '', sort:1,isdefaultlist:false,serverError:false,
          selectedFilterList: {selectedFilters: {}, industry:[],business:[],application:[],offerSub:[],offerType:[]}};
         
      }
  
      componentDidMount(){
        const params = this.props.location.search;  
        var pageNumber = 1 
        var sort = 1
        var selected = this.state.selectedFilterList;
        //check for page number from previous search
        if(params != null & qs.parse(params,{ ignoreQueryPrefix: true }).page != undefined)
        {
          pageNumber = parseInt(qs.parse(params,{ ignoreQueryPrefix: true }).page)
             if(isNaN(pageNumber))
             pageNumber = 1
            
             //set selected Filters from previous search
              if(sessionStorage.getItem("filters") != null)
              {
                selected = JSON.parse(sessionStorage.getItem("filters"))     
                           
              } 

              if(sessionStorage.getItem("sortBy") != null)
               sort = sessionStorage.getItem("sortBy")

        }
        else
        {
          if(sessionStorage.getItem("filters") != null)
            sessionStorage.removeItem("filters")

            sessionStorage.setItem("sortBy" , sort)  
        } 

        if(params != null & qs.parse(params, { ignoreQueryPrefix: true }).searchKey != undefined)
      {
       
        this.setState({searchKey: decodeURIComponent(qs.parse(params, {ignoreQueryPrefix: true }).searchKey),
        selectedFilters: selected.selectedFilters, 
        selectedIndustry:selected.industry,
        selectedBusiness:selected.business,
        selectedApplication:selected.application,
        selectedOfferingType:selected.offerType,
        selectedSubType:selected.offerSub,
        selectedFilterList: selected,
        sort:sort,
        pageNumber:pageNumber        
      } , () =>{
          this.getSearchProducts(this.state.searchKey,pageNumber)
  
        })
      }
      else
      {
           
        this.setState({selectedFilters: selected.selectedFilters, 
          selectedIndustry:selected.industry,
          selectedBusiness:selected.business,
          selectedApplication:selected.application,
          selectedOfferingType:selected.offerType,
          selectedSubType:selected.offerSub,
          selectedFilterList: selected,
          isdefaultlist:isEmptyObj(selected.selectedFilters) != false?true:false,
          pageNumber:pageNumber,
          sort:sort, },() =>{
          
        this.getDefaultProductData(pageNumber) })
      } 
       
      sessionStorage.setItem("backUrl", window.location.href)
      sessionStorage.setItem("pageNumber", pageNumber)
       
      }

            //get default Product List sorted by MembershipRank and created Date
    getDefaultProductData(pageNumber) {

      const request = {
          method: "POST", 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
      },
        body: JSON.stringify({searchKey:'',industryName:[],industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offeringType:this.state.selectedOfferingType,subType:this.state.selectedSubType,
         pageNum:pageNumber,isreload:this.state.isreload,sort:this.state.sort})    
      }

     fetch( Config.url + "defaultOffersList",request)
        .then(response => response.json())
        .then(data => {  
          if(data.result != null ) 
          {
                       
              this.setState( {productData : data.result.content, totalPages:data.result.totalPages, totalItemCount:data.result.totalElements,showProgress:false } )
              
          } 
          else
          this.setState( {productData : [], totalPages:0, totalItemCount:0,showProgress:false,serverError:true})  
            
        }).catch((error) => {     
         
         this.setState( {productData : [], totalPages:0, totalItemCount:0,showProgress:false,serverError:true})
        }).finally(()=>{window.scrollTo(0,0)});
    }
    

      
    //Get results for search
    getSearchProducts(searchKey, pageNumber){

      this.setState({searchKey : searchKey})

      const request = {
          method: "POST", 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
      },
        body: JSON.stringify({searchKey:searchKey,industryName:[],industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offeringType:this.state.selectedOfferingType,subType:this.state.selectedSubType,
         pageNum:pageNumber,isreload:this.state.isreload,sort:this.state.sort})    
      }

       fetch( Config.url + "offerSearchByRelevance",request)
        .then(response => response.json())
        .then(data => {  
          if(data.result != null ) 
          {
            this.setState( {productData : data.result.content, totalPages:data.result.totalPages, totalItemCount:data.result.totalElements,showProgress:false } )
              
          }   
          else
          this.setState( {productData : [], totalPages:0, totalItemCount:0,showProgress:false,serverError:true } )
         
        }).catch((error) => {     
        
         this.setState( {productData : [], totalPages:0, totalItemCount:0,showProgress:false,serverError:true } )
        }).finally(()=>{ this.setState( {showProgress:false})
          window.scrollTo(0,0)});

    }

    
    showFilters(selected)
    {
    
     
      this.setState({
        selectedFilters : selected.strFilter,
        pageNumber :1,
        isreload: true,
        selectedIndustry : this.getSelectedIdInArray(selected.industry),
        selectedBusiness : this.getSelectedIdInArray(selected.business),
        selectedApplication : this.getSelectedIdInArray(selected.application),
        selectedOfferingType : this.getSelectedIdInArray(selected.offerType),
        selectedSubType: this.getSelectedIdInArray(selected.offerSub),
        selectedFilterList: {selectedFilters : selected.strFilter,
          industry : this.getSelectedIdInArray(selected.industry),
          business : this.getSelectedIdInArray(selected.business),
          application : this.getSelectedIdInArray(selected.application),
          offerType : this.getSelectedIdInArray(selected.offerType),
          offerSub: this.getSelectedIdInArray(selected.offerSub)},
          showProgress: true,
          isdefaultlist:(this.state.searchKey == '' & selected.strFilter.length == 0)?true:false
      }, () =>{
        sessionStorage.setItem("filters",JSON.stringify(this.state.selectedFilterList))
        sessionStorage.setItem("pageNumber",1)
          if(this.state.searchKey != '')
           this.getSearchProducts(this.state.searchKey,1)
           else
           this.getDefaultProductData(this.state.pageNumber)
           this.updateUrl("page",1)

           if( devicetype == "mobile" || devicetype == "tablet")
           this.setState({ toggleKey: '' });
      }) ;  
     
      selected?.industry?.map(industry =>  ReactGA.send({hitType:'pageview',page:`/products/filter/${industry.label}`}))
      
    }
   

   // Get filter selected as array with only Id
   getSelectedIdInArray(filterlist)
   {
         var arrSelectedFilter = []
         var filters =[]
              if(filterlist.length > 0)
               filterlist.map(filter =>{
                 
                  //for offering sub type split multiple ids if exist
                if(filter.value.toString().indexOf(",") > 0)
                    filters = filter.value.split(",")
                else
                    filters[0] =  filter.value

                filters.map(value => arrSelectedFilter.push(value))
               } )  
        return arrSelectedFilter;

   }


   
  //On page change
  handlePageChange(obj_selected){
  
  const currentPageNumber = obj_selected.selected+1 
  this.setState({pageNumber:currentPageNumber,showProgress: true, isrelaod:false}, () =>{
  if(this.state.searchKey.trim()  == '')
  this.getDefaultProductData(currentPageNumber)
  else
  this.getSearchProducts(this.state.searchKey, currentPageNumber)

  this.updateUrl("page",currentPageNumber)
  sessionStorage.setItem("pageNumber", currentPageNumber) 
  })
  
}
      
      toggleSidebar = (event) => {
        if(this.state.toggleKey == '')
           this.setState({ toggleKey: 'toggled' });
           else
           this.setState({ toggleKey: '' });
      }

      getDescription(product_description, description, offerId, offerName)
      {
           
           if(product_description != null & product_description != '')         
           {
             
            description = product_description.replace(/<p>/g, '').replace(/<\/p>/g,'&nbsp;'). replace(/\.s+/g,"").replace(/<br>/g,'').substring(0,400)
          
           if(description.lastIndexOf(".") != -1)
           description = description.substring(0 ,description.lastIndexOf("."))                     
           
           }
           else if(description != null & description != '')         
           {
             
            description = description.replace(/<p>/g, '').replace(/<\/p>/g,'&nbsp;'). replace(/\.s+/g,"").replace(/<br>/g,'').substring(0,400)
             
           
           }

           description = description +'&nbsp;&nbsp;<a href="/products/'+offerId+"_"+offerName.toLowerCase().replace(/ /g,"_")+'" style="font-size:1em;color:#233F87;font-weight:500">more..</a>'
           
          
           return renderHTML(description)
            //return description
       }

        
      //On Sort By Change
      onSortChange = (sortBy) =>{
  
        this.setState({sort : sortBy, showProgress: true, isreload: true,pageNumber:1}, ()=>{
          if(this.state.searchKey != '')
          this.getSearchProducts(this.state.searchKey,1)
          else
          this.getDefaultProductData(1)

          this.updateUrl("page",this.state.pageNumber )
          sessionStorage.setItem("sortBy", sortBy)
        })
        

     }


     searchProducts =(e) => {
      e.preventDefault()
   
      this.setState({isdefaultlist: false},()=>{
        if(this.state.searchKey != '' & this.state.searchKey != null)
        window.location.href = window.location.origin+"/products?searchKey="+encodeURIComponent(this.state.searchKey)
        else
        window.location.href = window.location.origin+"/products"
      })
      
     
     }

          //Update URL query parameters
  updateUrl = (paramkey , value) =>
  {
    // Construct URLSearchParams object instance from current URL querystring.
     var queryParams = new URLSearchParams(window.location.search);

    // Set new or modify existing parameter value. 
     queryParams.set(paramkey, value);
     window.history.replaceState(null,null,"?"+queryParams.toString())

       sessionStorage.setItem("backUrl",window.location.href)
  }

   onProductClick = (path) => {
    //ReactGA.initialize(Config.google_analytics_tracking_id);
    ReactGA.send({hitType:'pageview',page:path})
    ReactGA.send({hitType:'pageview',page:`/offerings/TOC/OC${path}`})
   }

  

    render() {

      if(this.state.serverError == true)
           return <Redirect to="/error" />
        return (
          <div>
            <div>
            <Helmet>
            <title>{Config.meta_title}</title>
            <meta name="title" content={Config.meta_title} />            
            <meta name="description" content={Config.meta_description} />
            <meta name="og:title" content={Config.meta_title}/>
            <meta name="og:description" content={Config.meta_description} />
            <meta name="og:image" content={ Config.s3bucket+"favicon.ico"}/>
            <meta name="og:url" content={window.location.href}/>
            <meta name="og:type" content="article"/>
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:title" content={Config.meta_title}/>
            <meta name="twitter:description" content={Config.meta_description}/>
            <meta name="twitter:image" content={ Config.s3bucket+"favicon.ico" }/>
            <meta name="keywords" content={Config.meta_keywords}/>
            </Helmet>
            </div>
            {this.state.showProgress?<Loader />:null}
          <Header link1 ="HOME" link2="ABOUT US" link3="Log In"/>
            <div className="sticky">
            <div className="row col-lg-12 mb-0 p-0 m-0">
            <div className="col-lg-5 p-0" style={{marginLeft:"10%"}}>
               <HeaderMenu link2="active-menu"/> 
            </div>   
               <div className="col-lg-5">
               <div className="search-box-2 pt-1 pb-0">
                <form className="form-row justify-content-center" onSubmit={(e) => this.searchProducts(e) } >                  
                <div className="col-lg-12 search">
              <div className="input-group-md mb-1 col-lg-6" style={{float:"right"}}>
               <input type="text" className="form-control" placeholder="What are you looking for?" value={this.state.searchKey} onChange={(e) => this.setState({searchKey:e.target.value})}/>
               <i className="fa fa-search align-right search-icon" style={{marginTop:"-32px",position:'relative'}} aria-hidden="true" onClick={(e) => this.searchProducts(e) }></i>               
              </div>
            </div>           
            </form>
                </div>                
                 </div> 
               </div>               
               </div>               
               <div className={"d-flex "+ this.state.toggleKey }  id="wrapper" style={{paddingBottom:"50px"}}>
               <div className="" id="sidebar-wrapper" style={{minWidth:"300px"}}>
               <SidebarSub setData={this.state.selectedFilterList}  onChange={(selected) => this.showFilters(selected)} onClose={this.toggleSidebar}/>
                </div>
                <div id="page-content-wrapper">
                  <div className="container m-0">
                <div id="main" className="col-lg-12 p-0 m-0 pt-20">    
                <div className="row col-lg-12 m-0 p-0" > 
                             
                             <div className="col-lg-7 page-title p-0" ><span>Products, Solutions And Services</span> </div> 
                             <div className="col-lg-3 sort"><select className="form-control"  value={this.state.sort} style={{width:"220px"}}
                      onChange={(e) => this.onSortChange(e.target.value)}>
                        <option value="1">Sort By: Relevance</option>                        
                        <option value="2">Sort By: A-Z</option>
                        <option value="3">Sort By: Newest - oldest</option>
                      </select></div>                            
                             </div>                           
                      
                      <div className="container content">
                        <div className="row">
                          <div className="col-lg-12"> 
                      <div><button className="btn p-0" onClick={(e)=>this.toggleSidebar(e)} title="Click here to close or open Filters"><label style={{fontWeight:"600"}}>{this.state.toggleKey == ""?"Filters":"Close Filters"}</label><i className="fa fa-filter" /></button>                         
                      <div>{ this.state.selectedFilters.industry != null?
                            this.state.selectedFilters.industry.map((item,i) => (
                              <span key={"filter_"+i} className="badge badge-primary mr-2">{item.label}</span>
                            
                              )):null
                         } </div>
                          <div>{ this.state.selectedFilters.business != null?
                            this.state.selectedFilters.business.map((item,i) => (
                              <span key={"filter_"+i} className="badge badge-primary badge-2 mr-2">{item.label}</span>
                            
                              )):null
                         } </div>
                         <div>{ this.state.selectedFilters.application != null?
                            this.state.selectedFilters.application.map((item,i) => (
                              <span key={"filter_"+i} className="badge badge-primary badge-3 mr-2">{item.label}</span>
                            
                              )):null
                         } </div>
                         <div>{ this.state.selectedFilters.offeringSub != null?
                            this.state.selectedFilters.offeringSub.map((item,i) => (
                              <span key={"filter_"+i} className="badge badge-primary badge-4 mr-2">{item.label}</span>
                            
                              )):null
                         } </div>
                         <div>{ this.state.selectedFilters.offeringType != null?
                            this.state.selectedFilters.offeringType.map((item,i) => (
                              <span key={"filter_"+i} className="badge badge-primary badge-5 mr-2">{item.label}</span>
                            
                              )):null
                         } </div>                  
                        
                      </div></div>
                     
                        </div>
                       
                       
                       <div id="divresults" >
                       <div style={{marginBottom:"20px"}}>
                          {this.state.isdefaultlist == false?
                            this.state.totalItemCount > 0?<span className="listing-title" style={{color:"gray",fontWeight:"500",fontSize:"20px"}}>{this.state.totalItemCount  <= 100?this.state.totalItemCount : "100+"} results found</span>:<div><span className="listing-title" style={{fontWeight:"500",fontSize:"20px",color:"lightgray"}}>No results found for given search and filters</span></div>
                            :null
                           }
                          </div>
                    {this.state.productData.length >0 ?
                    this.state.productData.map(product => {
                       return(
                        <div className="card card-list card-listing my-2 pb-3" key={product.offerId}  data-id={product.offerId} style={{borderBottom:"1px solid lightgrey"}}>
                     
                        <div className="row">
        <div className="col-sm-3 col-xl-3 mr-1"> 
        <a href={"/products/"+encodeURIComponent(product.offerId+"_"+product.offerName.toLowerCase().replace(/ /g,"_"))}>   
        {product.offerImg != null & product.offerImg != ''?<img className="listing-img1" src={Config.s3bucket+product.offerImg} />: <img className="listing-img1" src={Config.s3bucket+defaultImage} alt="No Image Available"  /> }          
        </a>  
        </div>
        <div className="col-sm-8  col-xl-8">
            <div className="card-body p-0 pb-2 m-0">    
              <div
                className="d-flex  mb-1">              
                {product.companyLogo != null?<a onClick={() => ReactGA.send({hitType:'pageview',page:`/companies/${product.companyName}`})} href={"/companies/"+encodeURIComponent(product.companyId+"_"+product.companyName.toLowerCase().replace(/ /g,"_"))}  style={{fontSize:"22px",marginRight:"20px"}}><img style={{maxHeight:"100px",width:"100px"}} className="img-fit" src={Config.s3bucket+product.companyLogo} alt={product.companyName}/></a> : ''}
                <h3 className="card-title listing-title mb-1">
                <a onClick={() => this.onProductClick(`/products/${product.offerName}`)} href={"/products/"+encodeURIComponent(product.offerId+"_"+product.offerName.toLowerCase().replace(/ /g,"_"))}  style={{fontSize:"1.2em",fontWeight:"400"}}>{product.offerName}</a> 
                </h3>
              </div>
              <div className="mb-3">{this.getDescription(product.offerDescription, product.description,product.offerId,product.offerName)}</div>
                
            </div>
            
          </div>
      </div>
                          
                     </div>
                     

                       )



                    }) :null
                    }    
                     <div className="row col-lg-12 mt-3" style={{float:"right"}}>
                {
                this.state.totalItemCount > 0 & this.state.totalPages > 1?<Pagination
                previousLabel={'previous'}
                nextLabel={'next'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={this.state.totalPages}
                marginPagesDisplayed={5}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageChange.bind(this)}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                previousClassName = {'previous'}
                nextClassName = {'next'}
                initialPage ={this.state.pageNumber-1}
                forcePage = {this.state.pageNumber-1}
                /> : ''  }
                        </div>
                          </div>
                        
                          </div>
                     
                     </div>
                     
                     </div>
                </div>
              </div>
            <Footer/>
          
          </div>
        );
      }
  }
  
    export default Productlist;